import * as i0 from "@angular/core";
var GlobalFunctionService = /** @class */ (function () {
    function GlobalFunctionService() {
    }
    GlobalFunctionService.prototype.capitalizeFirstLetter = function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    GlobalFunctionService.prototype.formatDate = function (date) {
        if (typeof date !== 'undefined') {
            var dateString = new Date(date);
            var dateS = dateString.toLocaleDateString('fr-FR', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
            return this.capitalizeFirstLetter(dateS);
        }
        throw new Error('QuotationComponent : Could not format date');
    };
    //
    // ─── DOWNLOAD ───────────────────────────────────────────────────────────────────
    //
    GlobalFunctionService.prototype.download = function (file, fileName) {
        var a = document.createElement('a');
        a.href = file;
        a.style.display = 'none';
        a.download = fileName;
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
    };
    GlobalFunctionService.prototype.getMimeTypeFromName = function (name) {
        var extIndex = name.lastIndexOf('.');
        var ext = name.substring(extIndex + 1).toLowerCase();
        switch (ext) {
            case 'pdf':
                return 'application/pdf';
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg';
            case 'gif':
                return 'image/gif';
            case 'png':
                return 'image/png';
            case 'avi':
                return 'video/avi';
            case 'mov':
                return 'video/quicktime';
            case 'zip':
                return 'application/zip';
            case 'docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case 'doc':
                return 'application/msword';
            case 'xls':
                return 'application/vnd.ms-excel';
            case 'xlsx':
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case 'webm':
                return 'video/webm';
            default:
                return 'application/octet-stream';
        }
    };
    GlobalFunctionService.prototype.getImageFromBlob = function (image) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                resolve(reader.result);
            }, false);
            var blob = new Blob([image], { type: 'image/jpeg' });
            if (blob) {
                reader.readAsDataURL(blob);
            }
            else {
                reject(new Error('Image invalide'));
            }
        });
    };
    // Create and download file
    GlobalFunctionService.prototype.downloadFile = function (data, filename) {
        var _this = this;
        var name = filename;
        if (!name) {
            name = this.getFileNameFromHttpResponse(data);
        }
        var mimeType = this.getMimeTypeFromName(name);
        if (!mimeType) {
            return;
        }
        var blob = new Blob([data.body], { type: mimeType });
        var isChrome = window['chrome'] || navigator.userAgent.match('CriOS');
        var type;
        if (isChrome) {
            type = 'createObjectURL';
        }
        else {
            type = 'readAsDataURL';
        }
        if (navigator.msSaveBlob) {
            // IE11 and Edge 17-
            navigator.msSaveBlob(blob, name);
        }
        else {
            // every other browser
            var reader_1 = new FileReader();
            reader_1.onloadend = function () {
                var url;
                switch (type) {
                    case 'createObjectURL':
                        url = window.URL.createObjectURL(blob);
                        break;
                    case 'readAsDataURL':
                    default:
                        url = reader_1.result;
                }
                _this.download(url, name);
                if (type === 'createObjectURL') {
                    window.URL.revokeObjectURL(url);
                }
            };
            reader_1.readAsDataURL(blob);
        }
    };
    // Extract content-disposition headers value
    GlobalFunctionService.prototype.getFileNameFromHttpResponse = function (httpResponse) {
        var contentDispositionHeader = httpResponse.headers.get('content-disposition');
        var result = contentDispositionHeader
            .split(';')[1]
            .trim()
            .split('=')[1];
        return result.replace(/"/g, '');
    };
    GlobalFunctionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GlobalFunctionService_Factory() { return new GlobalFunctionService(); }, token: GlobalFunctionService, providedIn: "root" });
    return GlobalFunctionService;
}());
export { GlobalFunctionService };
